import type { CSSProperties } from "react";
import { useEffect, useState } from "react";

export interface SlideShowHideConfig {
  direction: string;
  duration: number;
  position: Record<string, string | number>;
  label?: string;
  id?: string;
}

export interface SlideShowHideResult {
  style: CSSProperties;
  shouldRender: boolean;
}

const INITIAL_POSITION = 100;
const TRANSLATE_MULTIPLIER = 1.1;

export function useSlideShowHideComponent(
  isVisible: boolean,
  config: SlideShowHideConfig = {
    direction: "right",
    duration: 300,
    position: {
      bottom: "50%",
      right: 0,
    },
  }
): SlideShowHideResult {
  const [position, setPosition] = useState(INITIAL_POSITION);

  useEffect(() => {
    if (isVisible) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setPosition(0);
        });
      });
    } else {
      setPosition(INITIAL_POSITION);
    }
  }, [isVisible]);

  const containerStyle: CSSProperties = {
    transform: `translate${config.direction === "right" || config.direction === "left" ? "X" : "Y"}(${config.direction.startsWith("-") ? -position * TRANSLATE_MULTIPLIER : position * TRANSLATE_MULTIPLIER}%)`,
    transition: `transform ${config.duration}ms linear`,
    willChange: "transform",
  };

  return {
    shouldRender: true,
    style: containerStyle,
  };
}
